<h1 mat-dialog-title>Warning unsaved changes</h1>
<div mat-dialog-content>
  <p>Are you sure you want to navigate away from this page? <b>All unsaved changes will be lost.</b></p>
  <p>Click 'Confirm' to navigate away.</p>
</div>
<div mat-dialog-actions style="justify-content: flex-end;">
  <button mat-flat-button (click)="dialogRef.close(false)">CANCEL</button>
  <button mat-flat-button (click)="dialogRef.close(true)" color="warn">CONFIRM</button>
</div>

